<template>
  <div class="">

    <Banner :background="(item.image) ? item.image : ''"
      :title="(!pgLoading) ? ($i18n.locale == 'en') ? item.en.title : item.ar.title : ''">
    </Banner>

    <div class="contact-area pb-70">
      <div class="container">
        <form @submit.prevent="sendMessage" id="contactForm">
          <h2>{{ $t('app.letstalk') }}</h2>
          <p></p>

          <div class="row">

            <div class="col-lg-12">
              <div class="form-group">
                <label>
                  <i class="icofont-user-alt-3"></i>
                </label>
                <input type="text" v-model="row.name" id="name" class="form-control"
                  :placeholder="$t('app.company_name')" required="required">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="form-group">
                <label>
                  <i class="icofont-ui-email"></i>
                </label>
                <input type="email" v-model="row.email" id="email" class="form-control" :placeholder="$t('app.email')"
                  required="required">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="form-group">
                <label>
                  <i class="icofont-notepad"></i>
                </label>
                <input type="text" v-model="row.subject" id="msg_subject" class="form-control"
                  :placeholder="$t('app.subject')" required="required">
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="form-group">
                <label>
                  <i class="icofont-comment"></i>
                </label>
                <textarea v-model="row.message" class="form-control" id="message" cols="30" rows="8"
                  :placeholder="$t('app.writeMessage')" required="required" data-error="Write your message"></textarea>
                <div class="help-block with-errors"></div>
              </div>
            </div>

            <div class="col-lg-12">
              <button type="submit" class="btn common-btn btn-size" :disabled="btnLoading">
                <span v-if="!btnLoading">
                  {{ $t('app.sendMessage') }}
                </span>
                <span v-if="btnLoading">
                  <!-- <div class="loader loader-xs loader-center"></div> -->
                  {{ $t('app.loading') }}
                </span>
              </button>
              <div id="msgSubmit" class="h3 text-center hidden"></div>
              <div class="clearfix"></div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import iziToast from 'izitoast';

export default {
  name: 'List',
  components: {
    Banner: () => import('@/components/Banner.vue'),
  },
  data() {
    return {
      //
      row: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },

      item: '',
      refs: 'pages/contactus',
      pgLoading: true,
      btnLoading: false,
    }
  },
  mounted() {
  },
  created() {
    //
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/' + this.refs,
        method: 'GET',
        data: {},
        headers: {
          appId: window.appID
        }
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          this.item = res.data.data.row;
        })
        .catch(() => {
          //
        })
        .finally(() => {
        });
    },

    sendMessage() {
      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/contact',
        method: 'POST',
        data: {
          name: this.row.name,
          email: this.row.email,
          subject: this.row.subject,
          message: this.row.message
        },
        headers: {
          appId: window.appID
        }
      }
      this.axios(options)
        .then(() => {
          this.btnLoading = false;

          iziToast.success({
            icon: 'bx bx-wink-smile',
            title: '',
            message: this.$t("app.message_sent")
          });
          this.clearForm();
        })
        .catch(err => {
          //
          this.btnLoading = false;
          iziToast.warning({
            icon: 'bx bx-angry',
            title: '',
            message: (err.response) ? err.response.data.message : '' + err
          });
        })
        .finally(() => {
        });
    },

    clearForm() {
      this.row.name = '';
      this.row.email = '';
      this.row.subject = '';
      this.row.message = '';
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px
}

.contact-area {
  padding-top: 70px;
}
</style>
